import {FC, memo} from "react";
import {ComplectationsProps} from "./Complectations-types";
import ComplectationsGroup from "../ComplectationsGroup/ComplectationsGroup";
import {generateUid, isPinsBlockId} from "../../utils/ApplicationUtils";
import {ComplectationsSectionSkeleton} from "../ComplectationsSection/ComplectationsSection-skeleton";
import {useRecoilValue} from "recoil";
import {stateMobileDrawerTabId, stateComplectationBlocks} from "../../data/atoms";
import {MobileGroupName} from "../../data";

const Complectations: FC<ComplectationsProps> = memo((props) => {
    const {onOptionSelect, isLoading} = props;

    const blocks = useRecoilValue(stateComplectationBlocks);

    const activeTab = useRecoilValue(stateMobileDrawerTabId);

    return isLoading ? (
        <>
            <ComplectationsSectionSkeleton/>
            <ComplectationsSectionSkeleton/>
            <ComplectationsSectionSkeleton hasTags/>
            <ComplectationsSectionSkeleton hasTags/>
        </>
    ) : (
        <>

            {blocks.map((block) => {
                const currentUid = generateUid(block.id);
                const showPins = isPinsBlockId(block.id) && activeTab === MobileGroupName.osnova;

                return (
                    <ComplectationsGroup
                        key={currentUid}
                        uid={currentUid}
                        isVisibleOnMobile={activeTab === currentUid || showPins}
                        block={block}
                        onOptionSelect={onOptionSelect}
                    />
                )
            })}

        </>
    )
});

export default Complectations;
